import React from 'react'
import FormikInput from '../../../../../components/inputs/FormikInput'
import { makeStyles } from "@mui/styles";
import { Grid, Typography } from '@mui/material';
import { Field } from 'formik';
import FormikInputTest from '../../../../../components/inputs/FormikInputTest';
import FormikAutocomplete from '../../../../../components/inputs/FormikAutoComplete';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: "10px",
    marginBottom: "10px",
  },
  containerStep: {
    backgroundColor: "#F5F5F5",
    // border:"solid 1px black",
    //   boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",
    padding: "30px"
  },
}));
const Invoice01 = (props) => {
  const classes = useStyles();
  const { formField: { FC }, values } = props;

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-end"
        spacing={2}
        marginTop={3}
      >

        <Grid item xs={1.5}>
          <Typography variant="h8" style={{color:"grey"}}>
            Nº Factura
        </Typography>
          <Field
            type="text"
            name="FC.sucursal"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
        <Grid item xs={1.5}>
          <Field
            type="text"
            name="FC.type"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />

        </Grid>
        <Grid item xs={2}>
          <Field
            // type="text"
            name="FC.invoiceNumber"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />

        </Grid>
        <Grid item xs={2}>
          <Typography variant="h8"  style={{color:"grey"}}>
            Fecha Del Documento
          </Typography>
          <Field
            type="text"
            name="FC.documentDate"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
        <Grid item xs={3}>
          <Typography variant="h8"  style={{color:"grey"}}>
            CAE/CAI/CAEA
          </Typography>
          <Field
            type="text"
            name="FC.CAE"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h8" style={{color:"grey"}}>
            Fecha de Vencimiento
          </Typography>
          <Field
            type="text"
            name="FC.expirationDate"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-end"
        spacing={2}
        marginTop={3}
      >

        <Grid item xs={3}>
          <Field
                    type="select"
                    name="FC.typeVoucher"
                    label="Tipo de Comprobante"
                    component={FormikAutocomplete}
                    options={InvoiceType}
                />
        </Grid>
        <Grid item xs={4}>
        <Field
                    type="select"
                    name="FC.typeBenefit"
                    label="Tipo de Prestacion"
                    component={FormikAutocomplete}
                    options={Prestacion}
                />
        </Grid>
        <Grid item xs={5}>
        <Field
                    type="select"
                    name="FC.typeActivity"
                    label="Tipo de Actividad"
                    component={FormikAutocomplete}
                    options={Activity}
                />
        </Grid>
      </Grid>


      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-end"
        spacing={2}
        marginTop={3}
      >
        <Grid item xs={3}>
          <Typography variant="h8" style={{color:"grey"}}>
            Moneda
          </Typography>
          <Field
            type="text"
            name="FC.currency"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h8" style={{color:"grey"}}>
            Importe con impuestos
          </Typography>
          <Field
            type="text"
            name="FC.amountWithTaxes"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
        <Grid item xs={3}>
          <Typography variant="h8" style={{color:"grey"}}>
            Tipo de Cambio
          </Typography>
          <Field
            type="text"
            name="FC.exchangeRate"
            component={FormikInputTest}  
            style={{width:"100%"}}      
          />
        </Grid>
      </Grid>


    </>
  )
}

export default Invoice01



const InvoiceType = [
  { label: 'Factura A', id: 1 },
  { label: 'Factura B', id: 2 },
  { label: 'Factura C', id: 3 },
]

const Prestacion = [
  { label: 'Materiales', id: 1 },
  { label: 'Servicios', id: 2 },
]

const Activity = [
  { label: 'Compra', id: 1 },
  { label: 'Venta', id: 2 },
]